import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './news.stub.css';

interface NewsStubProps {
    itemsCount: number;
    compact?: boolean;
    type?: string;
}

const class_ = b.with('news-stub');

const NewsStub: StatelessComponent<NewsStubProps> = ({ itemsCount, type, compact }) => {
    const items = Array(itemsCount).fill(0);

    if (compact) {
        return (
            <div className={class_({ type, compact })}>
                {items.map((_: any, index: number) => (
                    <div key={index} className={class_('item')}>
                        <Rect height={16} />
                        <Rect height={34} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={class_({ type, compact })}>
            {items.map((_: any, index: number) => (
                <div key={index} className={class_('item')}>
                    <Rect className={class_('image')} />
                    <div className={class_('content')}>
                        <Rect height={34} />
                        <div className={class_('description')}>
                            <Rect height={16} />
                            <Rect height={16} />
                        </div>
                        <Rect height={16} />
                        <Rect width={100} height={24} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NewsStub;
